import { faToggleOff } from "@fortawesome/free-solid-svg-icons";
import styles from "./app-switch.style.module.scss";
export interface Input extends Omit<Marko.HTML.Input, "type"> {
  off: string;
  on: string;
}

const/{ on, off, ...checkboxInput }=input

label class=styles.label
  span -- ${off}
  span class=styles.appSwitch
    input ...checkboxInput type="checkbox"
    fa-icon=faToggleOff
  span -- ${on}
